module.exports = __webpack_public_path__ + "media/dashboard/assets/images/opportunity-pipelines/home-no-pipelines-9feb468c03e919782c397e26b6ef5197.svg";